export const ETolgeeNamespaces = {
  DEFAULT: 'default',
  IAPP: 'iapp',
  ADMIN: 'admin',
  WEB_APP: 'web-app',
  PENSION: 'pension',
  CAMPAIGN: 'campaign',
  REQUESTS: 'requests',
  PROXY: 'proxy',
  OBSOLETE_PLAN: 'obsolete-plan',
  HOME: 'home'
} as const;

export type ETolgeeNamespaces =
  (typeof ETolgeeNamespaces)[keyof typeof ETolgeeNamespaces];
